module.exports = __webpack_public_path__ + "img/60.2f874121.jpg";